import Minicart from "./minicart"
import Helpers from "../helpers"

const Product = {
  product_images: null,

  init: function () {
    window.addEventListener(
      "popstate",
      function (event) {
        var variant_id = Helpers.getUrlParam(window.location.href, "variant")
        $(
          '.variants .select-item[data-variant-id="' + variant_id + '"]'
        ).trigger("click")
      },
      false
    )

    $(".formCartAdd").submit(function (e) {
      e.preventDefault()

      let requestData = $(this).serialize()
      const isPreorder = e.currentTarget.hasAttribute("data-preorder")
      if (isPreorder) {
        const formData = new FormData(e.currentTarget)
        if (formData.get("purchase_type") != "onetime") {
          const elSelect = document.querySelector(
            '[name="properties[shipping_interval_frequency]"]'
          )

          formData.set("properties[original_frequency]", elSelect.value)
          formData.set("properties[shipping_interval_frequency]", 365 * 2)

          requestData = new URLSearchParams(formData).toString()
        } else {
          formData.delete("properties[original_frequency]")
          requestData = new URLSearchParams(formData).toString()
        }
      } else {
        const formData = new FormData(e.currentTarget)
        requestData = new URLSearchParams(formData).toString()
      }

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: requestData,
        success: () => {
          $.getJSON("/cart.js", function (cart) {
            $(".modal, #overlay").fadeOut(250)
            $("body").removeClass("fixed")
            Minicart.checkForGift(cart, true)
            // Minicart.updateMinicart(cart, true);
          })
        },
        error: (XMLHttpRequest, textStatus) => {
          var data = eval("(" + XMLHttpRequest.responseText + ")")
          if (!!data.message) {
            alert(data.message + "(" + data.status + "): " + data.description)
          } else {
            alert(
              "Error : " + Shopify.fullMessagesFromErrors(data).join("; ") + "."
            )
          }
        },
      })
    })

    $("body").mouseup(function (e) {
      if (!$("#calendar").is(":visible")) return
      var container = $("#calendar")

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.addClass("hide")
      }
    })

    $(".variant_select").click(function () {
      if ($(this).attr("data-option1") != undefined) {
        $(
          '.variants .select-item[data-option1="' +
            $(this).attr("data-option1") +
            '"][data-option2="' +
            $(this).attr("data-option2") +
            '"][data-option3="' +
            $(this).attr("data-option3") +
            '"]'
        ).trigger("click")
      } else {
        $(
          '.variants .select-item[data-variant-title="' +
            $(this).attr("data-variant-title") +
            '"]'
        ).trigger("click")
      }
    })

    $(".variants .select-item").click(function () {
      if ($(this).hasClass("unavailable")) {
        $("#BIS_trigger").removeClass("hide")
        $(".add-to-cart").addClass("hide")

        return
      }

      $("#BIS_trigger").addClass("hide")
      $(".add-to-cart").removeClass("hide")
      $(".add-to-cart").removeAttr("disabled")
      $(".addToCartText").html($(".addToCartText").attr("data-label"))
      $(".addToCartPrice").removeClass("hide")

      $(this).closest(".potencies").find(".potency").removeClass("selected")
      $(this).addClass("selected")
    })

    // Variants (count > 3) selector
    $(`.select-container > .select-item`)
      .off("click")
      .on("click", function (e) {
        e.preventDefault()

        var $variant = $(this),
          variant_title = $variant.data("variant-title"),
          variant_id = $variant.data("variant-id"),
          variant_price = $variant.data("price"),
          $wrapper = $variant.closest(".select-container"),
          $form = $variant.closest("form"),
          product_id = $form.data("productid"),
          $product_form = $variant.closest('.productFormBlocks')

        // Update Selector
        $wrapper.find(".selected-item span").text(variant_title)

        if ( $('.addToCartPrice--onetime').is(':visible') ) {
          $product_form.find(".addToCartPrice--onetime .price").text(variant_price)
        }
        $product_form.find('data-rtx-onetime-price').text(variant_price)
        $wrapper.find(".select-item").removeClass("selected")
        $wrapper.find(".select-item").hide()
        $(this).addClass("selected")

        // Update Variant ID on the product form
        $form
          .find(`#product__options-${product_id}`)
          .val(variant_id)
          .trigger("change")
        var selectEl = $form.find(`#product__options-${product_id}`)[0]
        selectEl.dispatchEvent(new Event("change"))

        Product.updateFormsViaDropdown(this)
        Product.getActiveIngredient()
      })

    document.addEventListener('skio::select-selling-plan-group', function(e) {
      // e.detail.variant, e.detail.group, e.detail.key, e.detail.sellingPlan
      const $form = $('.formCartAdd');
      // Add your logic here
      $form
          .find(`#product__options-${e.detail.product.id}`)
          .val(e.detail.variant.id)
          .trigger("change");
        var selectEl = $form.find(`#product__options-${e.detail.product.id}`)[0];
        selectEl.dispatchEvent(new Event("change"));
    });

    $(".fixed-bar .add-to-cart").click(function () {
      $('.product-info .formCartAdd:visible .button[type="submit"]').trigger(
        "click"
      )
    })

    $("body")
      .on(`click`, `.variants .select-variant`, function (e) {
        var $this = $(this),
          $form = $this.closest("form"),
          product_id = parseInt($form.data("productid")),
          variant_id = $this.data("variant-id")
        
        $this.parent().find(".potency").removeClass("selected")
        $this.addClass("selected")

        // Update Product Form
        $form
          .find(`#product__options-${product_id}`)
          .val(variant_id)
          .trigger("change")
        var selectEl = $form.find(`#product__options-${product_id}`)[0]
        selectEl.dispatchEvent(new Event("change"))

        Product.updateProductImages($(this))
        Product.getActiveIngredient()
      })
      .on(`click`, `.variant_select`, function (e) {
        e.preventDefault()

        if ($(this).attr("data-option1") != undefined) {
          $(
            '.variants .select-variant[data-option1="' +
              $(this).attr("data-option1") +
              '"][data-option2="' +
              $(this).attr("data-option2") +
              '"][data-option3="' +
              $(this).attr("data-option3") +
              '"]'
          ).trigger("click")
        } else {
          $(
            '.variants .select-variant[data-variant-title="' +
              $(this).attr("data-variant-title") +
              '"]'
          ).trigger("click")
        }

        Product.getActiveIngredient()
      })

    $(document).ready(function () {
      if ($("body").hasClass("template-product")) {
        var currentScroll = $(window).scrollTop()
        if ($(".product_form + .five-icons").length > 0) {
          var product_info =
            $(".product_form + .five-icons").offset()["top"] +
            $(".product_form + .five-icons").height()
        } else {
          var product_info =
            $(".product_form").offset()["top"] + $(".product_form").height()
        }
        var productInfoOffset =
          $(".product-info").offset().top + $(".product-info").outerHeight()
        $(window).scroll(function (event) {
          if ($(".product-info.moving").length > 0) {
            var bottomDifference =
              $(window).scrollTop() + $(window).height() - productInfoOffset
            if (
              bottomDifference >= 0 &&
              bottomDifference <=
                $(".product-info").parent().outerHeight() -
                  $(".product-info").outerHeight()
            ) {
              $(".product-info.moving").css("top", bottomDifference)
            } else if (bottomDifference < 0) {
              $(".product-info.moving").css("top", 0)
            } else if (
              bottomDifference >
              $(".product-info").parent().outerHeight() -
                $(".product-info").outerHeight()
            ) {
              $(".product-info.moving").css(
                "top",
                $(".product-info").parent().outerHeight() -
                  $(".product-info").outerHeight()
              )
            }
          }

          // scrolling down
          if (
            currentScroll < $(window).scrollTop() &&
            currentScroll > product_info
          ) {
            $(".product_form .fixed-bar").addClass("open")

            // scrolling up
          } else {
            $(".product_form .fixed-bar").removeClass("open")
          }

          currentScroll = $(window).scrollTop()
        })
        $(window).resize(function (e) {
          product_info =
            $(".product_form").scrollTop() + $(".product_form").height()
        })

        if (typeof productOptions != "undefined") {
          for (var i = 0; i < productOptions.length; i++) {
            const vowels = ["a", "e", "i", "o", "u"]
            let indef = "a"
            const firstOptionLetter = productOptions[i][i][0].toLowerCase()
            if (vowels.includes(firstOptionLetter)) {
              indef = "an"
            }
            $(".single-option-selector:eq(" + i + ")")
              .filter(function () {
                return $(this).find("option").length > 1
              })
              .prepend(
                `<option value="">Select a ${indef} ${productOptions[i][i]}</option>`
              )
              .val("")
              .trigger("change")
          }
        }

        // -- Click first variant to adjust for OOS first load glitch
        if (document.querySelector(".product_form .variants a.selected-item")) {
          // Variant Dropdown support
          var initId = document
            .querySelectorAll(".product_form .variants a.selected-item")[0]
            .getAttribute("data-init-variant")
          if (typeof initId !== undefined && initId !== false) {
            $(
              '.product_form .variants .select-item[data-variant-id="' +
                initId +
                '"]'
            ).click()
          }
        } else if (
          document.querySelector(
            ".product_form .variants .flexitem.select-item"
          )
        ) {
          // 2 or 3 Variant Support
          $(".product_form .variants .flexitem.select-item.selected").click()
        }
      }

      var $memberOverlay = $(".membership-exclusive-overlay")
      if ($memberOverlay.length > 0) {
        $memberOverlay.css("opacity", 1)
      }
    })

    this.addEventListeners()
  },

  destroy: function () {
    console.log("Destroying Product instance...");
  
    // Remove popstate event listener
    window.removeEventListener("popstate", this.popstateHandler, false);
  
    // Remove all jQuery event listeners
    $(".formCartAdd").off("submit");
    // $("body").off("mouseup");
    $("body").off("click", ".fixed-bar .add-to-cart");
    $("body").off("click", ".variants .select-variant");
    $("body").off("click", ".variant_select");
    $(".variant_select").off("click");
    // $(".variants .select-item").off("click");
    // $(".select-container > .select-item").off("click");
  
    // Remove window scroll and resize event listeners
    // $(window).off("scroll");
    // $(window).off("resize");
  
    // Remove dynamically created elements if needed
    $(".membership-exclusive-overlay").remove();
  
    // Nullify properties to free memory
    this.popstateHandler = null;
    if (this.eventHandlers) {
      this.eventHandlers.forEach(({ element, event, handler }) => {
        element.removeEventListener(event, handler);
      });
      this.eventHandlers = []; // Clear stored event handlers
    }  
    
    console.log("Product instance destroyed.");
  },

  setSlick: function (slick) {
    this.product_images = slick

    $(".product_images").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        var $variant_image = $(this)
          .find('.slick-slide[data-slick-index="' + nextSlide + '"]')
          .find("[data-variant-id]")
        $(
          '.variants .select-item[data-option1="' +
            $variant_image.attr("data-option1") +
            '"][data-option2="' +
            $variant_image.attr("data-option2") +
            '"][data-option3="' +
            $variant_image.attr("data-option3") +
            '"]'
        ).trigger("click")
      }
    )
  },

  updateForms: function (that) {
    $(that)
      .closest(".product-info")
      .find('form input[name="id"]')
      .val($(that).attr("data-variant-id"))

    $(that)
      .closest(".product-info")
      .find('input[data-option="1"]')
      .val($(that).attr("data-option1"))
    $(that)
      .closest(".product-info")
      .find('input[data-option="2"]')
      .val($(that).attr("data-option2"))
    $(that)
      .closest(".product-info")
      .find('input[data-option="3"]')
      .val($(that).attr("data-option3"))

    $(".variant-title").text($(that).attr("data-variant-title"))

    // update images
    this.updateProductImages(that)

    if (
      $(that).attr("data-variant-id") != undefined &&
      Helpers.getUrlParam(window.location.href, "variant") !=
        $(that).attr("data-variant-id")
    ) {
      let isInMain = false
      document
        .querySelectorAll("#shopify-section-product div[data-variant-id]")
        .forEach((el) => {
          if (
            el.getAttribute("data-variant-id") ==
            $(that).attr("data-variant-id")
          ) {
            isInMain = true
          }
        })

      if (isInMain) {
        history.replaceState(
          {},
          "",
          "?variant=" + $(that).attr("data-variant-id")
        )
      }
    }
  },

  updateProductImages: function (that) {
    if (this.product_images) {
      if ($(that).attr("data-variant-id") !== undefined) {
        var index = $(".product_images")
          .find('[data-variant-id="' + $(that).attr("data-variant-id") + '"]')
          .closest(".slick-slide")
          .attr("data-slick-index")
      } else {
        var index = $(".product_images")
          .find(
            '[data-option1="' +
              $(that).attr("data-option1") +
              '"][data-option2="' +
              $(that).attr("data-option2") +
              '"][data-option3="' +
              $(that).attr("data-option3") +
              '"]'
          )
          .closest(".slick-slide")
          .attr("data-slick-index")
      }
      this.product_images.slickGoTo(index)
    }
  },

  updateFormsViaDropdown: function (that) {
    let isInMain = false
    document
      .querySelectorAll("#shopify-section-product div[data-variant-id]")
      .forEach((el) => {
        if (
          el.getAttribute("data-variant-id") == $(that).attr("data-variant-id")
        ) {
          isInMain = true
        }
      })

    // update images
    this.updateProductImages(that)

    if (
      $(that).attr("data-variant-id") != undefined &&
      Helpers.getUrlParam(window.location.href, "variant") !=
        $(that).attr("data-variant-id")
    ) {
      if (isInMain) {
        history.replaceState(
          {},
          "",
          "?variant=" + $(that).attr("data-variant-id")
        )
      }
    }

    // OOS
    if (isInMain) {
      // may need to dig into this on modals
      if ($(that).hasClass("unavailable")) {
        $("#BIS_trigger").removeClass("hide")
        $("#BIS_trigger").attr(
          "data-variant-id",
          $(that).attr("data-variant-id")
        )
        $(".add-to-cart").addClass("hide")
        $(".sezzle-shopify-info-button").addClass("hide")
      } else {
        $("#BIS_trigger").addClass("hide")
        $(".add-to-cart").removeClass("hide")
        $(".add-to-cart").removeAttr("disabled")
        $(".sezzle-shopify-info-button").removeClass("hide")
      }
    }
  },

  contains: function (parent, child) {
    return parent !== child && parent.contains(child)
  },

  getActiveIngredient: function () {
    if (document.querySelectorAll(".ingredients[data-flavor]").length == 0)
      return

    let flavor = false
    if (
      document.querySelector(
        ".product_form .product-info .variants.flavors .select-variant.selected"
      )
    ) {
      flavor = document
        .querySelector(
          ".product_form .product-info .variants.flavors .select-variant.selected"
        )
        .getAttribute("data-variant-title")
    }

    if (flavor == false) {
      const productId = document
        .querySelector(".product_form .product-info")
        .getAttribute("data-product-id")
      const elSelect = document.querySelector("#product__options-" + productId)
      if (elSelect) {
        flavor = elSelect.options[elSelect.selectedIndex].text.split(' / ')[0]
      }
    }

    document.querySelectorAll(".ingredients[data-flavor]").forEach((el) => {
      if (el.getAttribute("data-flavor") == flavor) {
        el.classList.add("selected")
      } else {
        el.classList.remove("selected")
      }
    })

    document
      .querySelectorAll(".productInfoIngredientsList[data-flavor]")
      .forEach((el) => {
        if (el.getAttribute("data-flavor") == flavor) {
          el.classList.add("selected")
        } else {
          el.classList.remove("selected")
        }
      })
  },

  addEventListeners: function () {
    const targetEl = document.querySelector("#shopify-section-product");
    if (!targetEl) return;
  
    const productId = document
      .querySelector(".formCartAdd")
      .getAttribute("data-productid");
  
    this.eventHandlers = []; // Store event handlers for cleanup
  
    if (targetEl.querySelector(".rtxRadio")) {
      const radios = targetEl.querySelectorAll(".rtxRadio");
      radios.forEach((radio) => {
        const radioChangeHandler = () => this.updateFixedBar();
        radio.addEventListener("change", radioChangeHandler);
        this.eventHandlers.push({ element: radio, event: "change", handler: radioChangeHandler }); // ✅ Store for removal
      });
    }
  
    if (targetEl.querySelector(`#product__options-${productId}`)) {
      const selectEl = targetEl.querySelector(`#product__options-${productId}`);
      const selectChangeHandler = () => this.updateFixedBar();
      selectEl.addEventListener("change", selectChangeHandler);
      this.eventHandlers.push({ element: selectEl, event: "change", handler: selectChangeHandler }); // ✅ Store for removal
    }
  
    this.updateFixedBar();
  
    if (targetEl.querySelector(".select-variant")) {
      setTimeout(() => {
        document.querySelector(".select-variant.selected").click();
      }, 50);
    }
  },

  updateFixedBar() {
    const targetEl = document.querySelector("#shopify-section-product")
    if (!targetEl) return

    const productId = document
      .querySelector(".formCartAdd")
      .getAttribute("data-productid")

    if (targetEl.querySelector(".rtxRadio")) {
      const radios = targetEl.querySelectorAll(".rtxRadio")
      let value = "Subscription Purchase"
      if (radios[1].checked) {
        value = "One-time Purchase"
      }

      document.querySelector(".fixed-bar .frequency-title").innerText = value
    }

    if (targetEl.querySelector(`#product__options-${productId}`)) {
      const selectEl = targetEl.querySelector(`#product__options-${productId}`)
      const value = selectEl.value
      const label = selectEl.options[selectEl.selectedIndex].innerHTML

      if ( document.querySelector(".fixed-bar .variant-title") ) {
        document.querySelector(".fixed-bar .variant-title").innerText = label
      }
      if ( document.querySelector(".fixed-bar .product-title") ) { 
        document.querySelector(".fixed-bar .product-title").innerText = label
      }

      document
        .querySelectorAll(".fixed-bar .variant_thumbnail")
        .forEach((el) => {
          if (el.getAttribute("data-variant-id") == value) {
            el.classList.add("selected")
          } else {
            el.classList.remove("selected")
          }
        })
    }
  },
}

export default Product
